
export default {
  methods: {
    formatCurrencyBrazil (value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    getMoneyApi (value) {
      console.log(parseFloat(value + '').toFixed(2))
      return parseFloat(value + '').toFixed(2)
    },
    setMoneyApi (value) {
      return value.parseFloat()
    },
    convertToNumberApi (value) {
      value = value.replace(/[^0-9]/g, '')
      const lastChar = value.substr(value.length - 2)
      const xStr = value.substring(0, value.length - 2)
      return parseFloat(xStr + '.' + lastChar)
    }
  }
}
